import {
  SendMiniStressNotificationData,
  ActionType,
} from "models/stressCheck/miniStressSendNotification";
import { IResponse } from "models";

export const sendMiniStressNotificationAction = (
  payload: SendMiniStressNotificationData
) => {
  return {
    type: ActionType.SEND_MINI_NOTIFICATION,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.SEND_MINI_NOTIFICATION_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.SEND_MINI_NOTIFICATION_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_SEND_MINI_NOTIFICATION,
  };
};
